import React, { useState, useEffect, useRef } from 'react';
import { debounce } from 'lodash/fp';
import request from 'utils/request_ajax';
import Criteria from 'components/Practice/Learner/Criteria';
import QuestionElementPrompt from 'components/Questions/shared/QuestionElementPrompt';
import HighFiveShareableLink from 'components/shared/HighFiveShareableLink';
import ZendeskInfo from './ZendeskInfo';

const ZendeskPracticeQuestion = ({ data, meta, i18n }) => {
  const [message, setMessage] = useState('');
  const [answerSubmitted, setAnswerSubmitted] = useState(!!data.givenAnswer);
  const isDisabled = meta.previewing || meta.finished;

  useEffect(() => {
    if (data.givenAnswer) {
      setMessage(data.givenAnswer.message);
    }
  }, [data.givenAnswer]);

  const saveAnswer = answer => {
    const answerData = { answer, question_id: data.questionId };
    request.postJSON(meta.saveUrl, answerData).then(() => {
      setAnswerSubmitted(true);
    });
  };

  const debouncedSaveAnswer = useRef(debounce(300, saveAnswer)).current;

  const handleReplyChange = e => {
    setMessage(e.target.value);
    const messageData = JSON.stringify({ message: e.target.value });
    debouncedSaveAnswer(messageData);
  };

  return (
    <div>
      <QuestionElementPrompt
        required={data.required}
        subject={data.subject}
        questionSubjectClass={meta.questionSubjectClass}
        labelErrorClass={meta.labelErrorClass}
        isGradable={data.isGradable}
        questionType="zendesk"
        elementHeaderClass={meta.elementHeaderClass}
        isPractice={data.isPractice}
      />
      <div className="ZendeskPracticeQuestion d-f fd-c ai-c">
        <ZendeskInfo
          data={data}
          isDisabled={isDisabled}
          meta={meta}
          handleReplyChange={handleReplyChange}
          message={message}
        />
        <div className="QuestionPrompt PracticeQuestion pt-24 p-24 fz-bigger lh-24 w-fill">
          <HighFiveShareableLink
            questionId={data.questionId}
            progressId={data.progressId}
            hasAnswerBeenSubmitted={answerSubmitted}
            isGradable={data.isGradable}
          />
          {data.criteria.length > 0 && (
            <>
              <span className="fw-b">{i18n.focus}</span>
              <Criteria criteria={data.criteria} i18n={i18n} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ZendeskPracticeQuestion;
